<script setup lang="ts">
// interface
interface Props {
  isVisible: boolean;
}

interface Emit {
  (e: "closeDialog", value: boolean): void;
  (e: "continueBooking", value: boolean): void;
}

// props
const props = defineProps<Props>();

// Emit
const emits = defineEmits<Emit>();
</script>

<template>
  <VDialog :model-value="props?.isVisible" max-width="490">
    <VCard>
      <VCardTitle class="headline">Continue Booking?</VCardTitle>
      <VCardText>
        We are currently holding the booking for you. <br />
        You have been inactive for a while. Do you want to continue with the
        booking?
      </VCardText>
      <VCardActions>
        <v-spacer></v-spacer>
        <VBtn color="error" variant="flat" @click="emits('closeDialog', false)"
          >No</VBtn
        >
        <VBtn
          color="success"
          variant="flat"
          text
          @click="emits('continueBooking', true)"
          >Yes</VBtn
        >
      </VCardActions>
    </VCard>
  </VDialog>
</template>
